// extracted by mini-css-extract-plugin
export default {"flag":"dhzLChNHKBiId16MFVFL","contextPrint":"NFyljoaadNwyDZzqZtR1"};